<template>
    <div class="dropdown">
        <button class="btn btn-sm btn-light-primary dropdown-toggle"
                type="button"
                id="addColumnDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :disabled="availableFields.length === 0"
        >
            Assign optional field
        </button>
        <div class="dropdown-menu shadow-lg" aria-labelledby="addColumnDropdown">
            <div v-for="field in availableFields" class="dropdown-item cursor-pointer" @click="$emit('add', field)">
                <div class="d-flex flex-column">
                    <div>
                        <Badge type="badge-secondary">
                            {{ field }}
                        </Badge>
                    </div>
                    <div class="font-size-sm text-muted">
                        {{ __('stock-upload.field_descriptions.' + field) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Badge from "../../Badge.vue";

export default {
    components: {Badge},

    props: {
        availableFields: Array
    }
}
</script>
